import { Typography } from '@mui/material';
import { useState } from 'react';
import { useGetAssemblyState } from 'src/hooks';
import { lang } from 'src/utils';

import {
  Container,
  InputBox,
  StatusText,
  SubmitButton,
} from './AssemblyState.styled';

export const AssemblyState = () => {
  const [assemblyId, setAssemblyId] = useState('');
  const [showStatus, setShowStatus] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const {
    data: [assemblyState],
  } = useGetAssemblyState([assemblyId]);

  const handleClick = () => {
    if (assemblyId.trim() === '') {
      setErrorMessage('Please enter an Assembly ID');
    } else {
      setShowStatus(true);
      setErrorMessage('');
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAssemblyId(e.target.value);
    setShowStatus(false);
    setErrorMessage('');
  };

  return (
    <Container>
      <Typography variant="h6">{lang.assemblyState}</Typography>
      <InputBox
        type="number"
        placeholder="Enter Assembly ID"
        value={assemblyId}
        onChange={handleInputChange}
      />
      <SubmitButton variant="contained" color="primary" onClick={handleClick}>
        Submit
      </SubmitButton>
      {errorMessage && <StatusText>{errorMessage}</StatusText>}{' '}
      {showStatus && !errorMessage && (
        <StatusText>
          {lang.state} {assemblyState?.state}
        </StatusText>
      )}
    </Container>
  );
};
